module.exports = __webpack_public_path__ + "img/model_1000.12163d0a.jpg";